import {
    baseIntComparator,
    numberFormatUtils,
} from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';
import SortType from './SortType';

const { N0, RAW } = numberFormatUtils;

const baseIntColumn: Partial<Column<ColumnType.INTEGER>> = {
    ...getBaseColumn(ColumnType.INTEGER),
    sortCompareFunction: baseIntComparator,
    textAlign: 'right',
};

export const adv = {
    ...baseIntColumn,
    name: 'ADV',
    dataField: 'adv',
    colFmt: N0,
    width: 70,
    tag: 'Market Data/ADV',
    desc: 'Average Daily Volume',
    defaultSortDesc: true,
};

export const clusterId = {
    name: 'Cluster Id',
    dataField: 'clusterId',
    colFmt: N0,
    width: 70,
    tag: 'Symbol Data/Cluster Id',
    desc: 'Cluster Id',
    allowSetFilter: true,
};

export const fillQty = {
    ...baseIntColumn,
    name: 'Traded Qty',
    dataField: 'fillQty',
    colFmt: N0,
    width: 76,
    tag: 'Order Data/Traded Qty',
    desc: 'Traded quantity',
    defaultSortDesc: true,
};

export const idx = {
    ...baseIntColumn,
    name: 'Seq Num',
    dataField: 'idx',
    colFmt: N0,
    width: 70,
    tag: 'Order Data/Seq Num',
    desc: 'Order sequence number',
    allowSetFilter: true,
    defaultSortDesc: true,
};

export const orderID = {
    ...baseIntColumn,
    name: 'Order ID',
    dataField: 'orderID',
    colFmt: RAW,
    width: 110,
    tag: 'Order Data/Order ID',
    desc: 'Order ID',
    textualQuickSearch: true,
};

export const qty = {
    ...baseIntColumn,
    name: 'Order Qty',
    dataField: 'qty',
    colFmt: N0,
    width: 70,
    tag: 'Order Data/Order Qty',
    desc: 'Ordered quantity',
    defaultSortDesc: true,
    sortType: SortType.BLANK,
};

export const rem = {
    ...baseIntColumn,
    name: 'Leaves Qty',
    dataField: 'rem',
    colFmt: N0,
    width: 77,
    tag: 'Order Data/Leaves Qty',
    desc: 'Number of shares remaining',
    defaultSortDesc: true,
};
